module.exports = __webpack_public_path__ + "img/client2.1dacf051.png";